"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReference = void 0;
const react_1 = require("react");
const prependBodyContainer = () => {
    const body = document.body;
    const element = document.createElement('div');
    body.prepend ? body.prepend(element) : body.insertBefore(element, body.firstChild);
    return element;
};
const removeBodyContainer = (element) => document.body.contains(element) && document.body.removeChild(element);
const getContainer = (container) => container && (typeof container === 'function' ? container() : container);
const useReference = (container) => {
    const [reference, setReference] = (0, react_1.useState)();
    let defaultContainer;
    (0, react_1.useEffect)(() => {
        const evaluatedContainer = getContainer(container);
        if (evaluatedContainer) {
            setReference(evaluatedContainer);
        }
        else {
            defaultContainer = prependBodyContainer();
            setReference(defaultContainer);
        }
        return () => {
            removeBodyContainer(defaultContainer);
        };
    }, [container]);
    return reference;
};
exports.useReference = useReference;
